// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    lensFolderLensCreatorRoleLensDeletionError: {
        id: "apps.lens.hooks.lensDelete.lensFolderLensCreatorRoleLensDeletionError",
        description: "Lens folder lens creator role lens deletion error.",
        defaultMessage: "You are not permitted to delete this lens because you are a Lens Folder Creator.",
    },
    lensAdAccountDistributionLensDeletionError: {
        id: "apps.lens.hooks.lensDelete.lensAdAccountDistributionLensDeletionError",
        description: "Lens ad account distribution lens deletion error.",
        defaultMessage: "This lens cannot be deleted because it is being used in one or more of your Ad Accounts.",
    },
    lensWithDigitalGoodsDeletionError: {
        id: "apps.lens.hooks.lensDelete.lensWithDigitalGoodsDeletionError",
        description: "Lens with digital goods deletion error.",
        defaultMessage: "This lens cannot be deleted because it contains one or more Digital Goods",
    },
    lensWithStatusDeletionError: {
        id: "apps.lens.hooks.lensDelete.lensWithStatusDeletionError",
        description: "Lens with status deletion error.",
        defaultMessage: "This lens cannot be deleted because its current status is {status}",
    },
    lensWithSourceApplicationDeletionError: {
        id: "apps.lens.hooks.lensDelete.lensWithSourceApplicationDeletionError",
        description: "Lens with source application deletion error.",
        defaultMessage: "This Lens cannot be deleted because it was create with Lens Maker.",
    },
});
